import classNames from 'classnames';
import {CartMiniProductItem} from '../CartMiniProductItem/CartMiniProductItem';
import React, {FC} from 'react';
import style from './style.module.scss';
import {ICart} from 'modules/cart/models';

interface IProps {
    className?: string;
    cartProductsList: ICart['products'];
    isOutOfStock?: boolean;
    isForModal?: boolean;
    isForHeaderPopup?: boolean;
}

export const CartProductsList: FC<IProps> = ({
    className,
    cartProductsList,
    isOutOfStock = false,
    isForHeaderPopup = false,
}) => {
    return (
        <ul className={classNames(style.cartProductsList, className)}>
            {cartProductsList.map((cartProduct) => (
                <li key={cartProduct.id}>
                    {isForHeaderPopup && <CartMiniProductItem {...cartProduct} isOutOfStock={isOutOfStock} />}
                </li>
            ))}
        </ul>
    );
};
